module.exports = __webpack_public_path__ + "static/media/KozGoPr6N-Regular.3cee479f.svg";